import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ComplianceComponent } from '../compliance/compliance.component';
import { FdnsVisitComponent } from './fdns-visit/fdns-visit.component';
import { PublicAccessComponent } from './public-access/public-access.component';
import { LcaComponent } from './lca/lca.component';
import { FdnsQaComponent } from './fdns-qa/fdns-qa.component';
import { ManageFdnsVisitComponent } from './manage-fdns-visit/manage-fdns-visit.component';
import { DirtyFormGuard } from 'src/app/dirty-form.guard';
import { I9FormsComponent } from './i9-forms/i9-forms.component';
import { PastDocumentsComponent } from './past-documents/past-documents.component';
import { PastDocumentsMenuComponent } from './past-documents-menu/past-documents-menu.component';
const routes: Routes = [
  {
    path: 'compliance',
    component: ComplianceComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'public-access'
      },
      {
        path: 'public-access',
        component: PublicAccessComponent
      },
      {
        path: 'private-access',
        component: LcaComponent
      },
      {
        path: 'fdns-qa',
        component: FdnsQaComponent,
      },
      {
        path: 'fdns-visit',
        component: FdnsVisitComponent,
      },
      {
        path: 'fdns-visit/manage-fdns/:id',
        component: ManageFdnsVisitComponent,
        canDeactivate: [DirtyFormGuard]
      },
      {
        path: 'fdns-visit/manage-fdns',
        component: ManageFdnsVisitComponent,
        canDeactivate: [DirtyFormGuard]
      },
      {
        path: 'i9-forms',
        component:I9FormsComponent,
      },
      {
        path: 'past-documents',
        component: PastDocumentsComponent,
      },
      {
        path: 'past-documents-menu',
        component: PastDocumentsMenuComponent,
      },
    ]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'compliance'
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComplianceRoutingModule { }
